import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DifficultyLevelQuiz } from '@edtech-ui/constants/quiz-type.enum';

@Component({
	selector: 'app-difficulty',
	standalone: true,
	imports: [FormsModule, CommonModule],
	templateUrl: './difficulty.component.html',
	styleUrl: './difficulty.component.scss'
})
export class DifficultyComponent {
	
	@Input() selected: string = DifficultyLevelQuiz.Easy;
	@Output() selectedChange = new EventEmitter<string>();
	_DifficultyType = DifficultyLevelQuiz;

	setDifficulty(diff: string) {
		this.selected = diff;
		this.selectedChange.emit(diff);
	}
}